import cx from 'classnames'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import './styles'

export default class PresenceIndicator extends PureComponent {
  static propTypes = {
    isConnected: PropTypes.bool,
    endUser: PropTypes.object.isRequired,
  }

  static defaultProps = {
    isConnected: false
  }

  render() {
    const { isConnected, endUser } = this.props

    if (!endUser) return false

    const lastActive = endUser.attributes.last_active ? `active ${moment(endUser.attributes.last_active).fromNow()}` : ''

    return (
      <div key="presence-indicator" className="flex dsg-Regular color-navy-dark end-user-info">
        <div
          style={{ marginRight: isConnected && '.25rem' }}
          className={cx("presence-indicator", { active: isConnected })}
        />
        <span>{ isConnected ? 'online now' : lastActive }</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/shared/PresenceIndicator/index.js